import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Constant.js";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  CardHeader,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/Home2.css";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Home2Navbar from "./Home2Navbar";
import Home2Footer from "./Home2Footer";
const Login2 = () => {
  const navigate = useNavigate();
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (event) => {
    if (!validateForm()) return;
    event.preventDefault();

    const data = {
      emailId,
      password,
    };

    try {
      const response = await fetch(API_URL + "api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Login Successful!");

        localStorage.setItem("token", result.token);
        localStorage.setItem("loginId", result.data.loginId);
        localStorage.setItem("userTypeId", result.data.userTypeId);
        localStorage.setItem("firstName", result.data.firstName);
        localStorage.setItem("lastName", result.data.lastName);
        localStorage.setItem("mobileno", result.data.mobileNo);
        localStorage.setItem("emailId", result.data.emailId);
        localStorage.setItem("isDeleted", result.data.isDeleted);

        if (result.data.userTypeId === 1) {
          // Handle Admin login
        } else if (result.data.userTypeId === 2) {
          localStorage.setItem("counselorId", result.data.counselorId); // ✅ Store counselorId
          GoCounsellorNext(result.data.loginId);
        } else {
          GoClientNext(result.data.loginId);
        }
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("An error occurred during login:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const GoClientNext = async (loginId) => {
    try {
      const response = await fetch(
        `${API_URL}api/Login/GetClientNextStepPage/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch course list");
      }

      const data = await response.json();
      navigate(data.result);
    } catch (err) {
    } finally {
    }
  };
  const GoCounsellorNext = async (loginId) => {
    try {
      const response = await fetch(
        `${API_URL}api/Login/GetCounsellorNextStepPage/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch course list");
      }

      const data = await response.json();
      navigate(data.result);
    } catch (err) {
    } finally {
    }
  };

  const validateForm = () => {
    if (!emailId || !password) {
      toast.warn("Please fill in all fields.");
      return false;
    }
    return true;
  };

  return (
    <>
      <Home2Navbar />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "50vh",
          background: "linear-gradient(to left,#fcfcfe)",
        }}
      >
        <Card 
          style={{
            marginBottom: "35px",
            width: "100%", // Make it responsive
            maxWidth: "450px", // Limit width on larger screens
            minHeight: "400px",
            boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            padding: "24px",
            border: "none",
          }}
        >
          <h4
            style={{
              color: "#080c77",
              textAlign: "left",
            }}
          >
            <b>Login</b>
            <br />
            <label style={{ fontSize: "15px", color: "#777" }}>
              Enter your credentials to access your account
            </label>
          </h4>
          <br />
          <CardBody style={{ padding: "0px" }}>
            {/* Email Field */}
            <FormGroup>
              <label
                htmlFor="email"
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Email
              </label>
              <Input
                id="email"
                type="email"
                placeholder="Email or Username"
                value={emailId}
                onChange={(e) => setEmailId(e.target.value)}
                required
                style={{
                  fontSize: "15px",
                  padding: "20px",
                  border: "1px solid rgb(242, 241, 245)",
                  borderRadius: "5px",
                  backgroundColor: "#fcfefe",
                  transition: "border 0.3s ease",
                  outline: "none",
                  boxShadow: "none",
                }}
                
                onMouseOver={(e) => {
                  e.target.style.border = "1px solid #080c77";
                }}
                onMouseOut={(e) => {
                  e.target.style.border = "1px solid rgb(242, 241, 245)";
                }}
              />
            </FormGroup>

            {/* Password Field */}
            <FormGroup>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label
                  htmlFor="password"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Password
                </label>
                <a
                  href="/forgot-password"
                  style={{
                    fontSize: "13px",
                    textDecoration: "none",
                  }}
                  className="forgot-password-link"
                >
                  Forgot Password?
                </a>
              </div>

              <div style={{ position: "relative" }}>
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    color: "#777",
                    cursor: "pointer",
                    zIndex: "2",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    border: "1px solid rgb(242, 241, 245)",
                    borderRadius: "5px",
                    backgroundColor: "#fcfefe",
                    transition: "border 0.3s ease",
                    outline: "none",
                    boxShadow: "none",
                  }}
                  
                  onMouseOver={(e) => {
                    e.target.style.border = "1px solid #080c77";
                  
                  }}
                  onMouseOut={(e) => {
                    e.target.style.border = "1px solid rgb(242, 241, 245)";
                  }}
                />
              </div>
            </FormGroup>

            {/* Login Button */}
            <center>
              <Button
                color="primary"
                size="md"
                onClick={handleSubmit}
                style={{
                  fontSize: "1rem",
                  borderRadius: "6px",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                  transition: "background 0.3s ease",
                  border: "none",
                  width: "100%",
                  backgroundColor: "#080c77",
                  fontWeight: "bold",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#de0f3f")}
                onMouseLeave={(e) => (e.target.style.background = "#080c77")}
              >
                Sign in
              </Button>
            </center>

            {/* Forgot Password */}
            <div className="text-center mt-3">
              Don't have an account? &nbsp;
              <a href="/forgot-password" className="forgot-password-link">
                <b>Register here</b>
              </a>
            </div>
          </CardBody>
        </Card>
      </div>
      <Home2Footer />
    </>
  );
};
export default Login2;
